"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const CarouselSlideRemoveButton_1 = tslib_1.__importDefault(require("../../../ui-lib/Carousel/CarouselSlideRemoveButton"));
const StopPlayerButton = (0, mobx_react_lite_1.observer)(({ classes }) => {
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    const playerCtx = (0, react_1.useContext)(context_1.PlayerUiContext);
    const publicKey = playerCtx === null || playerCtx === void 0 ? void 0 : playerCtx.multistreamPlayerPublicKey; // ts happiness idk
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null || playerCtx != null, "<AddPlayerButton/>");
    if (ctx == null || playerCtx == null) {
        return null;
    }
    if (ctx.activePublicKeys.length !== 1 && publicKey != null) {
        return react_1.default.createElement(CarouselSlideRemoveButton_1.default, { onClick: () => ctx.stopPlayer(publicKey), classes: classes });
    }
    return null;
});
/**
 *
 * @visibleName Add Player Button
 */
// eslint-disable-next-line react/function-component-definition
const StopPlayerButtonWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(CarouselSlideRemoveButton_1.default, { classes: classes, onClick: undefined, ...props }) },
        react_1.default.createElement(StopPlayerButton, { classes: classes, ...props })));
};
exports.default = StopPlayerButtonWithErrorBoundary;
//# sourceMappingURL=StopPlayerButton.js.map